/*
 * Copyright (c) 2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import React from "react";
import {useTranslation} from "react-i18next";
import clsx from "clsx";
import FeatherIcon from "components/FeatherIcon";

interface CompetitionActionButtonProps {
    isFreeSelect: boolean;
    isSelected: boolean;
    disabled?: boolean;
    className?: string;
    onClick: () => void;
}

const CompetitionActionButton = (props: CompetitionActionButtonProps) => {
    const {t} = useTranslation();

    const label = props.isFreeSelect
        ? props.isSelected
            ? t("Deselect competition")
            : t("Select competition")
        : props.isSelected
          ? t("Remove")
          : t("Add");

    return (
        <button
            className={clsx(
                "CompetitionActionButton min-h-[32px] min-w-[120px] flex flex-row items-center justify-center gap-x-1.5 shrink-0 rounded border border-black bg-white px-2 py-1 text-xs font-bold text-black leading-none hover:bg-gray-50 disabled:opacity-60 disabled:cursor-not-allowed",
                props.disabled && "border-dashed",
                props.className
            )}
            disabled={props.disabled}
            type={"button"}
            onClick={props.onClick}
        >
            {/*{props.isSelected ? <XCircleIcon className={"size-5 shrink-0"} /> : !props.isFreeSelect && <PlusCircleIcon className={"size-5 shrink-0"} />}*/}
            {props.isSelected ? <FeatherIcon className={"size-5 shrink-0"} name={"x-circle"} /> : !props.isFreeSelect && <FeatherIcon className={"size-5 shrink-0"} name={"plus-circle"} />}
            <span className={"whitespace-nowrap"}>{label}</span>
        </button>
    );
};

export default CompetitionActionButton;
